RivalIQ.apps.LandscapeSettings.module('views', function (views, App, Backbone, Marionette, $, _) {

    'use strict';

    views.Delete = RivalIQ.views.ItemView.extend({
        ui: {
            modal: '.modal'
        },
        events: {
            'click button.x-landscape-delete': 'deleteLandscape'
        },
        getTemplate: function () {
            const me = this;
            const canDelete = _.size(me.dependentUsers) === 0;
            const result = (canDelete ? '#landscapeSettingsDeleteModalTemplate' : '#landscapeSettingsCannotDeleteModalTemplate');
            return result;
        },
        onRender: function () {
            const me = this;
            me.ui.modal.modal();
        },
        serializeData: function () {
            const me = this;
            return _.extend(me.model.toJSON(), me.companyLimits, {
                dependentUsers: me.dependentUsers
            });
        },
        templateHelpers: function () {
            return {
                hasSwapped: function () {
                    const data = this;
                    return (_.get(data, 'credits.swapped') > 0);
                }
            };
        },
        loadData: function () {
            const me = this;
            const landscapeId = me.model.get('id');

            const fetches = [
                RivalIQ.state.account.getUsers(),
                $.getJSON('/api/account/limits/companies')
            ];

            return $.when.apply($, fetches)
                .done(function (users, data) {
                    me.companyLimits = data;
                    me.dependentUsers = users.filter(function (user) {
                        const readonlySettings = user.get('readonly_settings');
                        return _.get(readonlySettings, 'landscape_id') === landscapeId;
                    });
                });
        },
        deleteLandscape: function () {
            const me = this;
            const model = me.model;
            const landscapeId = model.get('id');
            const landscapes = _.filter(RivalIQ.state.user.get('landscapes'), function (landscape) {

                return landscape.id !== landscapeId;
            });

            const newActiveLandscape = _.head(landscapes);

            // first change the active landscape so that we can delete the old one
            $.ajax({
                type: 'PUT',
                url: `/api/setActiveLandscape/${newActiveLandscape.id}`
            })
                .done(function () {

                    // then delete the old active landscape
                    model.destroy().done(_.bind(me.onLandscapeDeleted, me));
                });
        },
        onLandscapeDeleted: function () {
            RivalIQ.execute('tracking:push:auth', RivalIQ.tracking.metric.DeletedLandscape);
            window.location = RivalIQ.state.product.get('defaultRedirectLocation');
        }
    });

});
